<template>
    <li class="description-list-item" :class="[{'justify-center': center, 'items-center': verticalCenter, 'description-list-item-column': column}]" role="listitem">
        <span v-if="title || $slots.title || $slots.prefix" class="description-list-title truncate" :style="{width: titleWidth, minWidth: titleWidth}" :title="title">
			<slot name="prefix"/>
			{{ title }}
			<slot name="title"/>
		</span>
        <component v-if="![undefined, null].includes(displayText) || $slots.text" :is="textTag" v-bind="linkProps" class="description-list-text" :class="[colorString ? 'text-' + colorString : '']" :style="{width: textWidth, color: colorHex}">
            <span v-if="![undefined, null].includes(displayText)" class="whitespace-pre-wrap" v-html="displayText"/>
            <slot name="text"/>

              <lazy-tooltip v-if="help" max-width="300" left :text="help" class="ml-8" with-touch>
                <lazy-icon :icon="helpIcon ?? icons.help" x-small force-size :color="color ? color : 'gray-400'"/>
            </lazy-tooltip>
        </component>
    </li>
</template>

<script>
import ListItemMixin from "../ListItemMixin";
    import {transformUrlsToLinks} from "@spoferan/spoferan-ts-core";
    import Linkable from "../../../mixins/Linkable";
	import {helpIcon} from "../../../config";

    export default {
        name: "DescriptionListItem",
        mixins: [ListItemMixin, Linkable],

        props: {
            title: {
                type: String,
                default: null
            },

            // The space for the text
            textSpace: {
                type: Number,
                default: 3 / 5
            },

            // Whether the given text includes links that should be displayed
            withLinks: {
                type: Boolean,
                default: false
            },

			verticalCenter: {
				type: Boolean,
				default: false
			},

            // Whether to align the title and text in column style
            column: {
                type: Boolean,
                default: false
            },

			helpIcon: {
				type: String,
				default: null
			},
        },

		data() {
			return {
				icons: {
					help: helpIcon,
				}
			}
		},

        computed: {
            textWidth() {
                if (this.column) {
                    return '100%';
                }

                return (100 * this.textSpace) + '%';
            },

            titleWidth() {
                if (this.column) {
                    return null;
                }

                return (100 - (100 * this.textSpace)) + '%';
            },

            displayText() {
				if (this.text === null || this.text === undefined) {
					return null;
				}

                if (this.withLinks) {
                    return transformUrlsToLinks(this.text.toString());
                }

                return this.text.toString();
            },

            textTag() {
                if (this.relativeTo) {
                    return resolveComponent('NuxtLink');
                }

                if (this.absoluteTo) {
                    return 'a';
                }

                return 'span';
            }
        }
    }
</script>
<style>
/*********************
  Inputs
**********************/
li.description-list-item {
  padding: 8px 0 !important;
  align-items: start;
}
li.description-list-item .description-list-title {
  display: flex;
  align-items: center;
  font-size: 15px;
}
li.description-list-item .description-list-text {
  font-size: 15px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #465050;
}
li.description-list-item .description-list-text > * {
  max-width: 100%;
}
li.description-list-item .description-list-text a:not(.chip):not(.btn) {
  color: #008200;
}
@media (max-width: 639px) {
  li.description-list-item .description-list-text {
    text-align: right;
    justify-content: flex-end;
  }
  li.description-list-item .description-list-text * {
    text-align: right;
  }
  li.description-list-item .description-list-text *.flex {
    justify-content: flex-end;
  }
}
li.description-list-item.description-list-item-column {
  flex-direction: column;
}
li.description-list-item.description-list-item-column > .description-list-text {
  margin-top: 8px;
  margin-left: 0;
}

.list-sm .description-list-item {
  padding: 6px 5px !important;
}
.list-sm .description-list-item .description-list-title {
  font-size: 13.5px;
}
.list-sm .description-list-item .description-list-text {
  font-size: 13.5px;
}

.description-list.description-list--right li.description-list-item .description-list-text {
  text-align: right;
  justify-content: flex-end;
}
.description-list.description-list--right li.description-list-item .description-list-text * {
  text-align: right;
}
.description-list.description-list--right li.description-list-item .description-list-text *.flex {
  justify-content: flex-end;
}
</style>